import { Global, css } from './css-in-js';
import { normalizeCSS } from './normalize';
import { rootCssVariables } from './helpers';
import { typography } from './brands';
import { useEffect } from 'react';
import { insertScriptToHiddenRecaptcha } from 'core/utilities/external-scripts';

export const interpolateCssVariables = css({ ...rootCssVariables });

const styles = css`
  :root {
    ${interpolateCssVariables}
  }
  ${normalizeCSS};
  ${typography};
`;

const GlobalStyles = () => {
  const { pathname } = window.location;

  useEffect(() => {
    insertScriptToHiddenRecaptcha();
  }, [pathname]);

  return <Global styles={styles} />;
};

export default GlobalStyles;
